import useIdentityStore from "../../../Zustand/identityStore";

/**
 * Whether the logged-in user is a GreaseBoss (internal) user, from the `is_gb_user`
 * token claim. The backend sends it as the string "true" (booleans are accepted too).
 *
 * Client-side UX gate only (e.g. the note "Internal only" toggle) — visibility of
 * internal data must still be enforced server-side.
 */
export default function useIsGbUser(): boolean {
  const isGbUser = useIdentityStore((x) => x.user?.profile?.is_gb_user);
  return isGbUser === true || isGbUser === "true";
}
